import React, { ReactElement } from 'react'
import { Flex, Image } from 'theme-ui'
import SOCBadge from 'images/organization/homepage/footer/soc2.png'

export default function CertificationBadges(): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '1.6rem',
        alignItems: ['center', 'flex-start'],
        justifyContent: ['center', 'flex-start'],
      }}
    >
      <Image alt="SOC Certified" src={SOCBadge} sx={{ width: '10rem' }} />
    </Flex>
  )
}
